export default "__VITE_ASSET__DnGoAifd__"